import { notification } from "antd";


export const showNotification = (message: string, description: string) => {
  notification.destroy();
  notification.info({
    message: `Notification ${message}`,
    description: `${description}`,
  });
};


 
